/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloads_Dropdown_Macos_UniversalInputs */

const en_downloads_dropdown_macos_universal = /** @type {(inputs: Downloads_Dropdown_Macos_UniversalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS (Universal)`)
};

const es_downloads_dropdown_macos_universal = /** @type {(inputs: Downloads_Dropdown_Macos_UniversalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS (Universal)`)
};

/**
* | output |
* | --- |
* | "macOS (Universal)" |
*
* @param {Downloads_Dropdown_Macos_UniversalInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const downloads_dropdown_macos_universal = /** @type {((inputs?: Downloads_Dropdown_Macos_UniversalInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloads_Dropdown_Macos_UniversalInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_downloads_dropdown_macos_universal(inputs)
	return en_downloads_dropdown_macos_universal(inputs)
});